import React from "react";
import { useNavigate } from "react-router-dom";
import SearchBar from "../components/SearchBar";
import "../css/HomePage.css"; 

const HomePage = () => {
  const navigate = useNavigate();
  return (
    <div className="app-container">
      {/* Fondo */}
      <div className="background-layer"></div>

      {/* Portada */}
      <div className="portada">
        <div className="login-header">
          <button className="login-button" onClick={() => navigate("/login")}>
            Login
          </button>
        </div>
      </div>

      {/* Perfil circular */}
      <div className="perfil-img"></div>

      {/* Buscador */}
      <div className="search-section">
        <SearchBar />
      </div>

      <footer className="footer">© Farmasite</footer>
    </div>
  );
};

export default HomePage;
